import { motion } from "framer-motion";

export default function StatementSection({ content, dataTestId }) {
  return (
    <section className="py-16 md:py-24" data-testid={dataTestId}>
      <div className="max-w-4xl mx-auto px-6 md:px-12">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="text-center"
        >
          <h2 className="font-sans text-3xl md:text-4xl font-bold text-foreground mb-6">{content.title}</h2>
          {content.paragraphs.map((paragraph) => (
            <p key={paragraph} className="font-body text-lg text-muted-foreground leading-relaxed mb-6">
              {paragraph}
            </p>
          ))}
          {content.highlight ? (
            <p className="font-sans text-xl font-medium text-highlight">{content.highlight}</p>
          ) : null}
        </motion.div>
      </div>
    </section>
  );
}
